import moment from 'moment';

export const isDateRangeMoreThanYear = (dateFrom, dateTo) =>
  moment(dateTo).diff(moment(dateFrom), 'year') >= 1;
